import { AsyncPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { SubscriptionsPageRoutingModule } from './subscriptions-routing.module';
import { SubscriptionsPageComponent } from './subscriptions.page';

@NgModule({
  declarations: [SubscriptionsPageComponent],
  imports: [IonicModule, SubscriptionsPageRoutingModule, AsyncPipe, DatePipe, MiscModule]
})
export class SubscriptionPageModule {}
